import createIdbStore from './idbStore';

export default createIdbStore('valueStore', {
  autoIncrement: false,
});
